import { render, staticRenderFns } from "./PublicLiability.vue?vue&type=template&id=78151836&"
import script from "./PublicLiability.vue?vue&type=script&lang=js&"
export * from "./PublicLiability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports